import React from 'react';
import CarMonth from './CarMonth';


export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dateToday: new Date(),
            carData:[]

        }
        this.months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        this.daysOfTheWeek = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'

        ];
    }

    componentDidMount() {
        this.getCarData(this.state.dateToday.getMonth()+ 1, this.state.dateToday.getFullYear())
    }



    getCarData = async(month, year) =>{
        let address = `http://192.168.100.2:36000/api/CarReservations/ReservationsCaledar?apiKey=8dhsa90jcdu9r03hfjdhfu09ehvjdsruefnhh90h&userToken=xxxxxxxxxxxx&carToken=xxxxxxxxxxxx&month=${month}&year=${year}`

        address = encodeURI(address)



        let r = await fetch(address)


            let rData = await r.json();

            // console.log('rData :', rData);

            if(rData.succes){
                this.setState({carData:rData.content})
            }
    }

    
    defaultData = (data) => {
   
 
        let myDate = new Date(data)
      
        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth()+1
        let month = ((lunaNormala <10? '0' : '') + lunaNormala );
        let day = (myDate.getDate()<10? '0' : '') +myDate.getDate();
        // console.log('today :', `${year}-${month}-${day}`);
        return `${year}-${month}-${day}`
      
       }

       minusLuna = () => {
        let luna = this.state.dateToday
      
        luna.setMonth(luna.getMonth() - 1)


        this.setState({
            dateToday: new Date(luna),
        
        },()=>{
            this.getCarData(this.state.dateToday.getMonth()+ 1, this.state.dateToday.getFullYear())
        })
    }


    plusLuna = () => {
        let luna = this.state.dateToday
    
        luna.setMonth(luna.getMonth() + 1)



        this.setState({
            dateToday: new Date(luna),
        
        },()=>{
            this.getCarData(this.state.dateToday.getMonth()+ 1, this.state.dateToday.getFullYear())
        })
    }
       
    


    
    render() {
        return (
            <div>
                {this.state.carData &&
                 <CarMonth 
                 months={this.months}
                 dayOfWeek={this.daysOfTheWeek}
                 minusLuna={this.minusLuna}
                 plusLuna={this.plusLuna}
                 events={this.state.carData}
                 luna={this.state.dateToday.getMonth()+ 1}
                 anul ={this.state.dateToday.getFullYear()}
                 today ={this.defaultData(this.state.dateToday)}
                 />
                }
               
            </div>
        );
    }
}